import '../sass/frontend.scss';
import IMask from 'imask';
import Sliders from './components/swiper-init';
import Popup from './parts/popup-window';
import { anchorLinkScroll } from './parts/helpers';
import checkLightMode from './components/checkLightMode';
import scrollToAnchorLinkAfterGoingToNewPage from './components/scrollToAnchorLinkAfterGoingToNewPage';
import toggleScrollBtnTop from './components/toggleScrollBtnTop';
import scrollHeader from './components/scrollHeader';
import closeBurgerMenu from './components/closeBurgerMenu';
function getCookie(name) {
    let cookie = {};
    document.cookie.split(';').forEach(function (el) {
        let [k, v] = el.split('=');
        cookie[k.trim()] = v;
    });
    return cookie[name];
}
function ready() {
    const popupInstance = new Popup();
    popupInstance.init();
    window.document.addEventListener('wpcf7mailsent', function (event) {
        const lang = getCookie('pll_language');
        window.location.replace('/' + lang + '/thank-you/');
    });
    anchorLinkScroll('a[href^="#"]:not(.js-open-popup-activator)', closeBurgerMenu, -100);
    anchorLinkScroll('.js-anchor-link');
    Sliders.initSwipers();
    const userPhoneElems = document.querySelector('.js-user-phone');
    if (userPhoneElems) {
        IMask(userPhoneElems, {
            mask: '+000 (00) 000 00 00',
        });
    }
    checkLightMode();
    scrollToAnchorLinkAfterGoingToNewPage(100);
    scrollHeader();
    window.document.addEventListener('scroll', () => {
        scrollHeader();
        toggleScrollBtnTop();
    });
    document.body.addEventListener('click', (event) => {
        const target = event.target;
        const ROLE = target.dataset.role;
        if (!ROLE)
            return;
        switch (ROLE) {
            case 'toggle-dark-mode': {
                const actionType = target.classList.contains('active') ? 'remove' : 'add';
                const darkModeLabels = window.document.querySelectorAll('.js-dark-mode-label');
                const darkModeElems = window.document.querySelectorAll('.js-dark-mode');
                if (!darkModeLabels || !actionType || !darkModeElems)
                    return;
                window.document.body.classList.toggle('light-mode');
                [...darkModeElems].forEach((item) => {
                    item.classList.toggle('active');
                });
                [...darkModeLabels].forEach((item) => {
                    item.classList.toggle('active');
                });
                actionType === 'add'
                    ? localStorage.setItem('light-mode', 'light-mode')
                    : localStorage.removeItem('light-mode');
                break;
            }
            case 'toggle-burger-menu': {
                const burgerMenu = window.document.querySelector('.js-burger-menu');
                if (!burgerMenu)
                    return;
                burgerMenu.classList.toggle('active');
                window.document.body.classList.toggle('open-burger-menu');
                break;
            }
            case 'see-more-text': {
                const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
                const actionType = target.classList.contains('opened') ? 'remove' : 'add';
                const parentSlide = target.closest('.js-c-studies-slide');
                const cStudiesTextElem = parentSlide ? parentSlide.querySelector('.js-case-studies-text') : null;
                const csSlideInfo = parentSlide ? parentSlide.querySelector('.js-cs-slide-info') : null;
                const targetScrollPos = csSlideInfo ? csSlideInfo.getBoundingClientRect().top : 0;
                if (!cStudiesTextElem && !parentSlide)
                    return;
                target.classList[actionType]('opened');
                cStudiesTextElem.classList[actionType]('opened');
                parentSlide.classList[actionType]('text-opened');
                setTimeout(() => {
                    Sliders.caseStudiesSlider.update();
                    if (actionType === 'remove') {
                        window.scroll({
                            behavior: 'smooth',
                            left: 0,
                            top: targetScrollPos + scrollTop,
                        });
                    }
                }, 350);
                break;
            }
            case 'scroll-to-top': {
                window.scroll({
                    top: 0,
                    behavior: 'smooth',
                });
                break;
            }
            default:
                break;
        }
    });
}
window.document.addEventListener('DOMContentLoaded', ready);
